import BadgesCard from "@components/BasicComponents/Cards/BadgesCards/BadgesCard"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Separator from "@components/CustomTypography/Separator/Separator"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {
	AdvancedSideAssetModuleType,
	BadgesModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./CompanyBadgesSection.module.scss"
type Props = {
	data: AdvancedSideAssetModuleType
	badges: BadgesModuleType[]
}

const CompanyBadgesSection = (props: Props) => {
	const mainContent = props.data.mainContent
	return (
		<section style={{background: "#F8FAFE"}}>
			<ContainerWrapper>
				<Separator size={128}>
					<Typography
						content={props.data.sectionTitle}
						variant={Variant.SectionTitle}
					/>
					<Separator>
						<div className={styles.cardsContainer}>
							{props.badges.map(
								(element: BadgesModuleType, index: number) => {
									return (
										<BadgesCard
											key={index}
											className={styles.cardBox}
											data={element}
										/>
									)
								},
							)}
						</div>
					</Separator>
					{mainContent && (
						<div className={styles.bottomBadge}>
							<Typography
								className={styles.bottomBadgeDesc}
								content={mainContent[0].content}
								variant={Variant.Description}
							/>
							{mainContent?.[0].preview && (
								<NewResponsiveImage
									containerClassName={
										styles.bottomBadgeImgContainer
									}
									imageClassName={styles.bottomBadgeImg}
									{...mainContent?.[0].preview}
									alt={
										mainContent?.[0].title ??
										mainContent?.[0]?.preview?.alt
									}
								/>
							)}
						</div>
					)}
				</Separator>
			</ContainerWrapper>
		</section>
	)
}

export default CompanyBadgesSection
